// extracted by mini-css-extract-plugin
module.exports = {"root":"AddressesRow_root__2eKrp"};